import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from 'i18next-http-backend';

// Cache-busting: use build timestamp injected by Vite
const buildVersion = import.meta.env.VITE_BUILD_TIMESTAMP || Date.now();

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ['en', 'uk', 'de'],
    fallbackLng: "en",
    ns: ['common', 'riskCheck'],
    partialBundledLanguages: true,
    defaultNS: 'common',
    detection: {
      order: ["cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["cookie", "localStorage"],
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${buildVersion}`,
    },
    react: { useSuspense: true },
  });

export default i18n;
